/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {SettlementReportQueryContract} from './settlement-export-excel/contracts/settlement-report-query.contract';
import {SettlementReportResultContract} from './settlement-export-excel/contracts/settlement-report-result.contract';

@Injectable({
    providedIn: 'root'
})
export class SettlementsExportExcelApi {
    private settlementsBaseUrl = `${environment.settlementsBaseUrl}/api/settlement`;
    private settlementsReport = 'report/search';

    constructor(private http: HttpClient) {
    }

    getSettlementsReport(queryModel: SettlementReportQueryContract, businessConfiguration: string):
            Observable<SettlementReportResultContract> {
        return this.http.post<SettlementReportResultContract>(`${this.settlementsBaseUrl}/${businessConfiguration}/` +
                `${this.settlementsReport}`, queryModel);
    }

    getSettlementsTodoReport(queryModel: SettlementReportQueryContract, businessConfiguration: string):
            Observable<SettlementReportResultContract> {
        return this.http.post<SettlementReportResultContract>(`${this.settlementsBaseUrl}/${businessConfiguration}/` +
                `${this.settlementsReport}/toDo`, queryModel);
    }
}
